/**
 * Small builders the starter and library templates are written with. Not part
 * of the package's surface (index.ts does not export it): a template is plain
 * data, and these only save writing the same edge or condition by hand.
 */

import type { Condition, TemplateEdge } from "./template.js";

export const onlyFor = (...types: string[]): Condition => ({
  field: "employeeType",
  op: "in",
  values: types,
});
export const notFor = (...types: string[]): Condition => ({
  field: "employeeType",
  op: "notIn",
  values: types,
});
export const triggerIs = (...triggers: string[]): Condition => ({
  field: "trigger",
  op: "in",
  values: triggers,
});
export const triggerIsNot = (...triggers: string[]): Condition => ({
  field: "trigger",
  op: "notIn",
  values: triggers,
});
/** The answer to one of the template's questions is Yes. */
export const yes = (question: string): Condition => ({ question, op: "in", values: ["yes"] });

export const hard = (from: string, ...to: string[]): TemplateEdge[] =>
  to.map((target) => ({ from, to: target, kind: "hard" }));
export const soft = (from: string, ...to: string[]): TemplateEdge[] =>
  to.map((target) => ({ from, to: target, kind: "soft" }));

/**
 * The federal COBRA steps as the Department of Labor gives them: the employer
 * tells the plan administrator within 30 days of the end of employment, and the
 * administrator sends the election notice within 14 days of that (44 days in
 * all when the employer is the administrator). The card is due sooner than the
 * law, so the instance does not stay open for six weeks over it.
 */
export const COBRA_DESCRIPTION =
  "COBRA covers group health plans of employers with 20 or more employees; a smaller employer may be under a state continuation law. Report the end of employment to the plan administrator within 30 days (it is due sooner here). The administrator then has 14 days to send the election notice, 44 days in all when the employer is the administrator. Skip this card, with the reason, if the person was not on the plan or the employer is under 20 employees. Guidance from the Department of Labor, not legal advice.";

/** USCIS's rule, said the same way wherever an I-9 card appears. */
export const I9_DESCRIPTION =
  "Section 1 is the employee's, by the end of their first day. Section 2 is yours, within 3 business days after the first day, with the original documents in person. Keep the form 3 years after the hire or 1 year after the job ends, whichever is later. Guidance from USCIS, not legal advice.";
